import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';

Vue.directive('scroll', {
    inserted: function (el, binding) {
      let f = function (evt) {
        if (binding.value(evt, el)) {
          window.removeEventListener('scroll', f);
        }
      }
      window.addEventListener('scroll', f)
    }
})

Vue.use(VueScrollTo) 

Vue.use(VueScrollTo, {
     container: "body",
     duration: 1000,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true,
 })